// **********************************************************
// Image Text Animations
// **********************************************************

const imageTextImages = document.querySelectorAll('.image-text__image img');

imageTextImages.forEach((image) => {
  const parentElem = image.closest('.image-text__image');

  gsap.to(image, {
    y: '20%',
    ease: 'none',
    scrollTrigger: {
      trigger: parentElem,
      start: 'top 80%',
      end: 'bottom top',
      scrub: true,
    },
  });
});
